// // assets
// import { ProductOutlined, UserOutlined,EnvironmentOutlined,GlobalOutlined,NodeIndexOutlined } from '@ant-design/icons';

// // icons
// const icons = {
//   EnvironmentOutlined,
//   ProductOutlined,
//   UserOutlined,
//   GlobalOutlined,
//   NodeIndexOutlined
// };

// // ==============================|| MENU ITEMS - USER MASTER ||============================== //

// const masterData= {
//   id: 'group-master',
//   title: 'Master Data',
//   type: 'group',
//   children: [
//     {
//       id: 'distributorMaster',
//       title: 'Distributor Master',
//       type: 'item',
//       url: '/distributor-master',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'retailerMaster',
//       title: 'Retailer Master',
//       type: 'item',
//       url: '/retailer-master',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'farmerMaster',
//       title: 'Farmer Master',
//       type: 'item',
//       url: '/farmer-master',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'productMaster',
//       title: 'Product Master',
//       type: 'item',
//       url: '/product-master',
//       icon: icons.ProductOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'locationMaster',
//       title: 'Location Master',
//       type: 'item',
//       url: '/location-master',
//       icon: icons.EnvironmentOutlined,
//       breadcrumbs: false
//     },
//      {
//       id: 'regionMaster',
//       title: 'Region Master',
//       type: 'item',
//       url: '/region-master',
//       icon: icons.GlobalOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'territoryMaster',
//       title: 'Territory Master',
//       type: 'item',
//       url: '/territory-master',
//       icon: icons.NodeIndexOutlined,
//       breadcrumbs: false
//     },
//   ]
// };

// export default masterData;




// // assets
// import { ProductOutlined, UserOutlined, EnvironmentOutlined, GlobalOutlined, NodeIndexOutlined } from '@ant-design/icons';

// const icons = {
//   EnvironmentOutlined,
//   ProductOutlined,
//   UserOutlined,
//   GlobalOutlined,
//   NodeIndexOutlined
// };

// const masterData = (roleID) => {
//   return roleID == 1
//     ? {
//         id: 'group-master',
//         title: 'Master Data',
//         type: 'group',
//         children: [
//           { id: 'distributorMaster', title: 'Distributor Master', type: 'item', url: '/distributor-master', icon: icons.UserOutlined, breadcrumbs: false },
//           { id: 'retailerMaster', title: 'Retailer Master', type: 'item', url: '/retailer-master', icon: icons.UserOutlined, breadcrumbs: false },
//           { id: 'farmerMaster', title: 'Farmer Master', type: 'item', url: '/farmer-master', icon: icons.UserOutlined, breadcrumbs: false },
//           { id: 'productMaster', title: 'Product Master', type: 'item', url: '/product-master', icon: icons.ProductOutlined, breadcrumbs: false },
//           { id: 'locationMaster', title: 'Location Master', type: 'item', url: '/location-master', icon: icons.EnvironmentOutlined, breadcrumbs: false },
//           { id: 'regionMaster', title: 'Region Master', type: 'item', url: '/region-master', icon: icons.GlobalOutlined, breadcrumbs: false },
//           { id: 'territoryMaster', title: 'Territory Master', type: 'item', url: '/territory-master', icon: icons.NodeIndexOutlined, breadcrumbs: false }
//         ]
//       }
//     : {
//         id: 'group-master',
//         title: '',
//         type: 'group',
//         children: []
//       };
// };

// export default masterData;




// // assets
// import { ProductOutlined, UserOutlined,EnvironmentOutlined,GlobalOutlined,NodeIndexOutlined } from '@ant-design/icons';

// // icons
// const icons = {
//   EnvironmentOutlined,
//   ProductOutlined,
//   UserOutlined,
//   GlobalOutlined,
//   NodeIndexOutlined
// };

// // ==============================|| MENU ITEMS - USER MASTER ||============================== //

// const masterData= {
//   id: 'group-master',
//   title: 'Master Data',
//   type: 'collapse',
//   icon: icons.UserOutlined,  
//   children: [
//     {
//       id: 'distributorMaster',
//       title: 'Distributor Master',
//       type: 'item',
//       url: '/distributor-master',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'retailerMaster',
//       title: 'Retailer Master',
//       type: 'item',
//       url: '/retailer-master',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'farmerMaster',
//       title: 'Farmer Master',
//       type: 'item',
//       url: '/farmer-master',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'productMaster',
//       title: 'Product Master',
//       type: 'item',
//       url: '/product-master',
//       icon: icons.ProductOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'locationMaster',
//       title: 'Location Master',
//       type: 'item',
//       url: '/location-master',
//       icon: icons.EnvironmentOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'regionMaster',
//       title: 'Region Master',
//       type: 'item',
//       url: '/region-master',
//       icon: icons.GlobalOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'territoryMaster',
//       title: 'Territory Master',
//       type: 'item',
//       url: '/territory-master',
//       icon: icons.NodeIndexOutlined,
//       breadcrumbs: false
//     },
//   ]
// };

// export default masterData;






import { ProductOutlined, UserOutlined, EnvironmentOutlined, GlobalOutlined, NodeIndexOutlined } from '@ant-design/icons';

const icons = { EnvironmentOutlined, ProductOutlined, UserOutlined, GlobalOutlined, NodeIndexOutlined };
const roles = [0,1,2];

const masterData = {
  id: 'group-master',
  title: 'Master Data',
  type: 'collapse',
  icon: icons.UserOutlined,
  roles,
  children: [
    { id: 'distributorMaster', title: 'Distributor Master', type: 'item', url: '/distributor-master', icon: icons.UserOutlined, breadcrumbs: false, roles },
    { id: 'retailerMaster', title: 'Retailer Master', type: 'item', url: '/retailer-master', icon: icons.UserOutlined, breadcrumbs: false, roles },
    { id: 'farmerMaster', title: 'Farmer Master', type: 'item', url: '/farmer-master', icon: icons.UserOutlined, breadcrumbs: false, roles },
    { id: 'productMaster', title: 'Product Master', type: 'item', url: '/product-master', icon: icons.ProductOutlined, breadcrumbs: false, roles },
    { id: 'locationMaster', title: 'Location Master', type: 'item', url: '/location-master', icon: icons.EnvironmentOutlined, breadcrumbs: false, roles },
    { id: 'regionMaster', title: 'Region Master', type: 'item', url: '/region-master', icon: icons.GlobalOutlined, breadcrumbs: false, roles },
    { id: 'territoryMaster', title: 'Territory Master', type: 'item', url: '/territory-master', icon: icons.NodeIndexOutlined, breadcrumbs: false, roles }
  ]
};

export default masterData;
